import { PlanTypes } from '@gonfalon/billing/types';
import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';

import type { Plan } from '../types';

import { foundation2025Plan } from './foundation2025Plan';
import { aiRunsFeature } from './products';

export const foundation2025PlanPostTrial: Plan = {
  ...foundation2025Plan,
  id: `${PlanTypes.FOUNDATION2025}-post-trial`,
  recommended: true, // Foundation2025 should be recommended by default in post-trial
  marketingCopy: {
    ...foundation2025Plan.marketingCopy,
    featuresHeader: 'Foundation plan includes',
    features: [
      { text: 'Unlimited projects and environments' },
      { text: 'Unlimited feature flags' },
      {
        text: '8 service connections per month',
        tooltip: {
          text: '1 server-side SDK connected to a LaunchDarkly environment for one month',
          ctaTarget: getDocumentationUrl('home/account/service-connections'),
        },
      },
      {
        text: '1K client-side MAU',
        tooltip: {
          text: 'Each client-side user or device creates a client-side MAU',
          ctaTarget: getDocumentationUrl('home/account/calculating-billing'),
        },
      },
      aiRunsFeature,
      { text: 'A/B tests and experimentation' },
      {
        text: 'First-class mobile SDKs, attributes and targeting',
      },
      { text: 'Comprehensive audit log' },
      {
        text: '5K sessions',
        tooltip: {
          text: '1 recorded user session (a single instance of a tab) captured and stored for one month',
          ctaTarget: getDocumentationUrl('home/observability/session-replay'),
        },
      },
      {
        text: '5K errors',
        tooltip: {
          text: '1 unique instance of an error or exception captured and stored for one month',
          ctaTarget: getDocumentationUrl('home/observability/errors'),
        },
      },
      {
        text: '10M traces',
        tooltip: {
          text: 'A single span ingested, stored, and searchable for one month',
          ctaTarget: getDocumentationUrl('home/observability/traces'),
        },
      },
      {
        text: '10M logs',
        tooltip: {
          text: 'A single log line ingested, stored, and searchable for one month',
          ctaTarget: getDocumentationUrl('home/observability/logs'),
        },
      },
    ],
  },
};
